import jp from 'jsonpath';

export const getAllEntities = (schema: any) => {
  let query = "$..items[?(@.data.kind=='entity')].data";
  let entities = retrieveListData(query, schema);
  let response: any[] = Array.of();

  entities.forEach(item => {
    response.push(item.namespace.name + ':' + item.name);
  });
  return response;
};

export const getParentAttributes = (e: string, schema: any) => {
  if (e.indexOf(':') == -1) return [];
  const entityArr = e.split(':');
  const namespace = entityArr[0];
  const entity = entityArr[1];
  let query = "$..items[?(@.data.name=='" + entity + "')].data";
  let entries = retrieveListData(query, schema);
  let res: any[] = Array.of();
  entries.forEach(item => {
    if ((item.kind == 'entity', item.namespace.name == namespace && item.attributeDefinitions.attributes != null)) {
      res.push(...Object.keys(item.attributeDefinitions.attributes));
      if (item.parentType != null) {
        res.push(...getParentAttributes(item.parentType, schema));
      }
    }
  });
  return res;
};

export const getAllAttributesByEntity = (e: string[], schema: any) => {
  if (e && e.length != 0) {
    let query = "$..items[?(@.data.name=='" + e[0] + "')].data";
    let entities = retrieveListData(query, schema);
    let response: any[] = Array.of();

    entities.forEach(item => {
      if (item.kind == 'entity' && item.attributeDefinitions.attributes != null) {
        response.push(...Object.keys(item.attributeDefinitions.attributes));
      }
      if (item.kind == 'entity' && item.parentType != null) {
        response.push(...getParentAttributes(item.parentType, schema));
      }
    });
    return response;
  }
  return [];
};

export const getParentMetricTypes = (e: string, schema: any) => {
  if (e.indexOf(':') == -1) return [];
  const entityArr = e.split(':');
  const namespace = entityArr[0];
  const entity = entityArr[1];
  let query = "$..items[?(@.data.name=='" + entity + "')].data";
  let entries = retrieveListData(query, schema);
  let res: any[] = Array.of();
  entries.forEach(item => {
    if ((item.kind == 'entity', item.namespace.name == namespace && item.metricTypes != null)) {
      res.push(...item.metricTypes);
      if (item.parentType != null) {
        res.push(...getParentMetricTypes(item.parentType, schema));
      }
    }
  });
  return res;
};

export const getAllMetricTypesByEntity = (e: string[], schema: any) => {
  if (e && e.length != 0) {
    let query = "$..items[?(@.data.name=='" + e[0] + "')].data";
    let entities = retrieveListData(query, schema);
    let response: any[] = Array.of();

    entities.forEach(item => {
      if (item.kind == 'entity' && item.metricTypes != null) {
        response.push(...item.metricTypes);
      }
      if (item.kind == 'entity' && item.parentType != null) {
        response.push(...getParentMetricTypes(item.parentType, schema));
      }
    });
    return response;
  }
  return [];
};

const retrieveListData = (query: string, schema: any) => {
  let values = jp.query(schema, query);
  let response = new Set<any>();
  values.forEach(ns => response.add(ns));
  return Array.from(response.values()).sort();
};

export const getEntityNameFromFullName = (fullNames: string[]) => {
  if (fullNames && fullNames.length != 0) {
    return fullNames.map((name: any) => {
      if (name) return name.split(':')[1];
    });
  }
  return [];
};
